import { useState } from "react";
import { format } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { fmtDate } from "@/lib/format";
import { CalendarDays } from "lucide-react";

export function DatePicker({ value, onChange, placeholder = "Pick date", testid }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" type="button" data-testid={testid}
          className={`justify-start font-mono bg-card border-border ${!value ? "text-slate-500" : ""}`}>
          <CalendarDays className="h-4 w-4 mr-2" />
          {value ? fmtDate(selected) : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-card border-border" align="start">
        <Calendar mode="single" selected={selected} initialFocus
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
